import React, { Component } from 'react';
import '../App.css';
import { render } from '@testing-library/react';
import 'bootstrap/dist/css/bootstrap.min.css';



class Footer extends Component{

    state={
        mention: 0,
        utilisation: 0,
    }

mention = e =>{

    if(this.state.mention == 0){
        this.setState({
            mention: 1
        })
    }
    else{
        this.setState({
            mention: 0
        })

    }

}

utilisation = e =>{

    if(this.state.utilisation == 0){
        this.setState({
            utilisation: 1
        })
    }
    else{
        this.setState({
            utilisation: 0
        })

    }

}


render(){

return(
<div>
    <div className="footerbloc">

        <a href="#" onClick={this.mention} style={{textDecoration: "none"}}>Mentions Légales</a>
        <p className="pp">By <a href="http://twitter.com/dyrudyru" target="blank" style={{textDecoration: "none"}}>Rudy</a></p>
        <a href="#" onClick={this.utilisation} style={{textDecoration: "none"}}>Utilisation des données</a>

    </div>

{this.state.mention == 1 && <div className="container blocmention">
    <h1 className="titlementions">Informations légales</h1>
    <p className="paramention">
    Statut du propriétaire : particulier<br></br>
    Propriétaire, créateur, responsable de publication, webmaster : Rudy Ceroli - Rudy.26.fr@gmail.com<br></br>
    Le responsable de la publication est une personne physique<br></br>
    Hébergeur : app.netlify.com & amen.fr<br></br>
    </p>

    <h1 className="titlementions">Accessibilité</h1>
    <p className="paramention">Le site https://mystifying-perlman-1bdce9.netlify.app/ - 'Animey' est par principe accessible aux utilisateurs 24/24h, 7/7j, sauf interruption, programmée ou non, pour les besoins de sa maintenance ou en cas de force majeure. En cas d’impossibilité d’accès au service, le webmaster s’engage à faire son maximum afin de rétablir l’accès au service.
    </p>

    <h1 className="titlementions">Liens hypertextes et cookies</h1>
    <p className="paramention">Le site https://mystifying-perlman-1bdce9.netlify.app/ contient un certain nombre de liens hypertextes vers d’autres sites (Clients, informations..). Cependant, Rudy Ceroli n’a pas la possibilité de vérifier l'ensemble du contenu des sites ainsi visités et décline donc toute responsabilité de ce fait quand aux risques éventuels de contenus illicites.
L’utilisateur est informé que lors de ses visites sur le site https://mystifying-perlman-1bdce9.netlify.app/, qu'aucun cookie n'est susceptible de s’installer automatiquement sur son ordinateur par l'intermédiaire de son navigateur. Un cookie est un bloc de données qui ne permet pas d'identifier l'utilisateur, mais qui enregistre des informations relatives à la navigation de celui-ci sur le site.</p>

</div>}


{this.state.utilisation == 1 && <div className="container blocmention">

<h1 className="titlementions">Utilisations des doonnées</h1>
    <p className="paramention">Le site n'utilise pas vos données renseignée à des fins commerciales. La connexion avec "Twitter" engendre la création d'un compte sur le site. Il est possible de supprimer celui-ci ici: <a>À venir</a></p>




</div>}







</div>




)}




}

export default Footer